import './App.css';
import { Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/th';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

// pages
import P404 from '@/containers/pages/404';
// portal
import Portal from './containers/pages/portal';
import Bento from './containers/bento';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.locale('th'); // use locale

function App() {
  return (
    <div className="p-4">
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimaryHover: 'currentColor', // Set hover primary color
            },
            Table: {},
            Menu: {
              fontSize: 18,
            },
          },
        }}
      >
        <Routes>
          <Route path="/" element={<P404 />} />
          <Route path="/route" element={<Portal />} />
          <Route path="/bento" element={<Bento />} />
        </Routes>
      </ConfigProvider>
    </div>
  );
}

export default App;
